<template>
  <div id="programdetail-dialog" class="custom-modal">
    <div class="modal-body" :class="activeTab == '2' ? '' : 'no-footer'">
      <transition name="el-fade-in" mode="out-in">
        <el-row class="programdetail-container">
          <el-tabs v-model="activeTab" @tab-click="handleClick" stretch>
            <el-tab-pane :label="$t('program.menu.details')" name="1">
              <div class="container-inner">
                <!-- Sub event section -->
                <div class="programdetail-subevent-header" v-if="currentProgram.subEventID != null">
                  <div class="programdetail-subevent-top">
                    <div class="programdetail-subevent-icon-box">
                      <i class="fas fa-link"></i>
                    </div>
                    <h5 class="subevent-title">{{ currentSubEvent.title }}</h5>
                    <div class="subevent-line"></div>
                    <div class="subevent-limit">{{ $t("register_limit", { stock: currentSubEvent.stock }) }}</div>
                    <template v-if="currentSubEvent.stock <= currentSubEvent.usage && currentSubEvent.usage != null">
                      <el-button round>{{ $t("program.menu.closedRegister") }}</el-button>
                    </template>
                    <template v-else-if="currentSubEvent.enableMobileRegistrations == false">
                      <el-button round>{{ $t("program.menu.closedRegister") }}</el-button>
                    </template>
                    <template v-else-if="currentSubEventRegistration">
                      <el-button disabled v-if="currentSubEventRegistration.status == 1" type="success" round>{{ $t("subevent_confirmed") }}</el-button>
                      <el-button disabled v-if="currentSubEventRegistration.status == 0" type="warning" round>{{ $t("subevent_pending") }}</el-button>
                    </template>
                    <template v-else>
                      <el-button @click="register" type="primary" :disabled="loading == 'subevent' || !isAttending" :loading="loading == 'subevent'" round>{{ $t("event.program.sub_event_register") }}</el-button>
                    </template>
                  </div>
                  <!-- <div class="subevent-details" v-html="currentSubEvent.details"></div> -->
                </div>
                <!-- Sub event section end -->

                <!-- Program info section -->
                <div class="programdetail-header">
                  <h5 class="programdetail-program-title">{{ currentProgram.title }}</h5>
                  <p class="programdetail-program-details ql-editor ql-container ql-snow" v-if="currentProgram.details != null && currentProgram.details != ''" v-html="currentProgram.details"></p>
                  <p v-if="getSaloon(currentProgram.saloonID)" class="programdetail-program-saloon">
                    <i class="fas fa-map-marker-alt" :style="'color:' + currentEvent.color + ';'"></i>
                    {{ getSaloon(currentProgram.saloonID).title }}
                  </p>
                  <div class="programdetail-program-dates">
                    <div class="programdetail-program-dates-item">
                      <div class="programdetail-program-dates-item-icon">
                        <i class="fas fa-clock" :style="'color:' + currentEvent.color + ';'"></i>
                      </div>
                      <div class="programdetail-program-dates-item-text">{{ getTime(currentProgram.startTime) }} - {{ getTime(currentProgram.endTime) }}</div>
                    </div>
                    <div class="programdetail-program-dates-item">
                      <div class="programdetail-program-dates-item-icon">
                        <i class="fas fa-calendar" :style="'color:' + currentEvent.color + ';'"></i>
                      </div>
                      <div class="programdetail-program-dates-item-text">{{ getDate(getDay(currentProgram.dayID).date) }}</div>
                    </div>
                  </div>
                </div>
                <!-- Program info section end -->

                <!-- Program review section -->
                <!-- <div class="programdetail-reviewcard" v-if="isAttending == true && currentProgram.type != 2">
                  <div class="programdetail-stars">
                    <vue-stars name="program-rate" active-color="#ffdd00" inactive-color="#999999" shadow-color="#ffff00" hover-color="#dddd00" :max="5" :value="currentProgramRate ? currentProgramRate.rate : 0" :readonly="true" char="★" inactive-char class />
                  </div>
                  <div class="programdetail-review">
                    <span v-if="currentProgramRate">{{ $t("program_rated") }}</span>
                    <el-button v-else :style="'background-color:' + currentEvent.color + ';'" @click="activeTab = '2'" type="primary" round>{{ $t("rate_program") }}</el-button>
                  </div>
                </div> -->
                <!-- Program review section end -->

                <!-- Program speakers section -->
                <div class="programdetail-section" v-if="currentProgramSpeakers.length > 0 && (currentProgram.type == 0 || currentProgram.type == 1)">
                  <div class="programdetail-section-header">
                    <div class="programdetail-section-header-iconbox">
                      <i class="fas fa-microphone" :style="'color:' + currentEvent.color + ';'"></i>
                    </div>
                    <div class="programdetail-section-header-title">{{ $t("program.menu.speakers") }}</div>
                  </div>
                  <div class="programdetail-section-body">
                    <div class="programdetail-section-speakers-container">
                      <div class="programdetail-section-speaker-item" v-for="(item, index) in currentProgramSpeakers.filter(x => x.speaker != null)" @click="$store.dispatch('getSpeaker', item.speakerID)" :key="index + item.speakerID">
                        <img :src="$imageus + item.speaker.image + '?width=200&height=200&mode=cover'" :alt="item.speaker.fullName" />
                        <div class="programdetail-section-speaker-item-text">
                          <div class="programdetail-section-speaker-item-fullName">{{ item.speaker.fullName }}</div>
                          <div class="programdetail-section-speaker-item-title">
                            {{ item.speaker.title }}
                            <b v-if="item.speaker.firmName != null && item.speaker.firmName != ''">@ {{ item.speaker.firmName }}</b>
                          </div>
                          <div class="programdetail-section-speaker-item-title" v-if="item.speaker.presentations.some(x => x.id == item.speakerPresentationId)">{{ item.speaker.presentations.find(x => x.id == item.speakerPresentationId).title }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Program speakers section end -->

                <!-- Program SuvEvent Programs Section -->
                <div class="programdetail-section" v-if="currentSubEventPrograms.length > 1 && currentProgram.subEventID != null">
                  <div class="programdetail-section-header">
                    <div class="programdetail-section-header-iconbox">
                      <i class="fas fa-calendar" :style="'color:' + currentEvent.color + ';'"></i>
                    </div>
                    <div class="programdetail-section-header-title">{{ $t("other_programs", { program: currentSubEvent.title }) }}</div>
                  </div>
                  <div class="programdetail-section-body">
                    <div class="programdetail-section-subevent-program-container">
                      <div class="subevent-program-item" v-for="(item, index) in currentSubEventPrograms.filter(x => x.id != currentProgram.id)" :key="index">
                        <div class="subevent-program-item-details">
                          <div class="date">
                            <span>
                              <i class="fas fa-clock" :style="'color:' + currentEvent.color + ';'"></i>
                              {{ getTime(item.startTime) + " - " + getTime(item.endTime) }}
                            </span>
                            <i :style="'color:' + currentEvent.color + ';'" class="fas fa-long-arrow-alt-right"></i>
                            <span v-if="getSaloon(item.saloonID).title != null && getSaloon(item.saloonID).title != undefined && getSaloon(item.saloonID).title != ''">
                              <i class="fas fa-map-marker-alt" :style="'color:' + currentEvent.color + ';'"></i>
                              {{ getSaloon(item.saloonID).title }}
                            </span>
                          </div>
                          <span>{{ getDate(getDay(item.dayID).date) }}</span>
                        </div>

                        <div class="subevent-program-title" @click="$store.dispatch('getProgram', item.id)">
                          <p>{{ item.title }}</p>
                        </div>

                        <div class="subevent-program-speakers">
                          <div v-for="speaker in item.speakers.filter(x => x.speakerID != null)" :key="speaker.speakerID + index">
                            <template v-if="getSpeakerById(speaker.speakerID) != null">
                              <el-tooltip effect="dark" placement="top">
                                <div slot="content" style="text-align:center">
                                  <span>
                                    <b>{{ getSpeakerById(speaker.speakerID).fullName }}</b>
                                  </span>
                                  <br />
                                  <span>
                                    <template v-if="getSpeakerById(speaker.speakerID).title">{{ getSpeakerById(speaker.speakerID).title }}</template>
                                    <b v-if="getSpeakerById(speaker.speakerID).firmName">@ {{ getSpeakerById(speaker.speakerID).firmName }}</b>
                                  </span>
                                </div>
                                <div class="subevent-program-speakers-item" @click="$store.dispatch('getSpeaker', speaker.speakerID)" :style="'background-image: url(' + $imageus + getSpeakerById(speaker.speakerID).image + '?width=200&height=200&mode=cover);'"></div>
                              </el-tooltip>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Program SuvEvent Programs Section End-->

              <!-- Program subevent programs section -->
              <!-- <div class="programdetail-subevent-program-container" v-if="currentSubEventPrograms.length > 1 && currentProgram.subEventID != null">
                <h5>{{ $t("other_programs", { program: currentSubEvent.title }) }}</h5> -->

              <!-- Program subevent programs section end -->
              <!-- </div> -->
            </el-tab-pane>

            <el-tab-pane :label="$t('program.menu.appreciations')" name="2">
              <div class="container-inner">
                <Nodata v-if="currentProgramRates.length == 0" :title="$t('nodatakeys.programreviews.nodatatitle')" :description="$t('nodatakeys.programreviews.nodatadesc')" anim="holacon-rate-lottie" />

                <template v-else>
                  <div class="reviews-review-item" v-for="item in currentProgramRates" :key="item.id + 'program-detail-rates'">
                    <div class="review-item-header">
                      <div class="review-item-header-text">
                        <div v-if="item.user != null" class="review-item-photo" :style="'background-image: url(' + $imageus + item.user.image + '?width=200&height=200&mode=cover);'"></div>
                        <div v-else class="review-item-photo" style="background-image: url(../../static/500x500-user.png);"></div>
                        <div class="review-item-text">
                          <h5>
                            {{ item.user != null ? item.user.fullName : "" }}
                            <span>{{ moment(item.createDate).fromNow() }}</span>
                          </h5>
                          <div class="review-stars">
                            <vue-stars :name="item.id" active-color="#ffdd00" inactive-color="#999999" shadow-color="#ffff00" hover-color="#dddd00" :max="5" :value="item.rate" :readonly="true" char="★" inactive-char class />
                          </div>
                        </div>
                      </div>

                      <div class="review-item-actions">
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            <i class="fas fa-ellipsis-v"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="$root.$emit('getProfile', item.user.id)">
                              <span>
                                <i class="fa fa-eye"></i>
                                {{ $t("view_profile") }}
                              </span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="deleteReview(item.id)" v-if="item.user != null && item.user.id == $store.state.user.id">
                              <span>
                                <i class="fa fa-trash"></i>
                                {{ $t("delete") }}
                              </span>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <div class="review-item-body" v-html="item.comment"></div>
                  </div>
                </template>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="$t('program.menu.participants')" name="3" v-if="currentProgram.subEventID != null && isAttending">
              <div class="container-inner">
                <Participants v-if="activeTab == '3'" :subEventID="currentProgram.subEventID" />
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer">
      <template v-if="activeTab == '2'">
        <div class="left-buttons">
          <div class="review-bar">
            <el-input :placeholder="currentProgramRate ? $t('program.menu.alreadyRate') : $t('write_rate_here')" :disabled="rateForm.loading || currentProgramRate || !isAttending" v-model="rateForm.comment"></el-input>
            <div class="review-stars">
              <vue-stars v-model="rateForm.rate" name="demos" active-color="#ffdd00" inactive-color="#999999" shadow-color="#ffff00" hover-color="#dddd00" :max="5" :value="currentProgramRate ? currentProgramRate.rate : 0" :readonly="rateForm.loading || currentProgramRate || !isAttending" char="★" inactive-char class="review-select-stars" />
            </div>
          </div>
        </div>
        <div class="right-buttons">
          <el-button type="primary" :loading="rateForm.loading" :disabled="rateForm.loading || currentProgramRate || !isAttending" @click="sendRate">{{ $t("send") }}</el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import moment from "moment/min/moment-with-locales";
import Participants from "../modules/Participants";
import axios from "axios";

export default {
  name: "ProgramDetailDialog",

  components: {
    InfiniteLoading,
    Participants
  },

  data() {
    return {
      moment,
      activeTab: "1",
      loading: null,
      rateForm: {
        rate: 5,
        comment: null,
        loading: false
      }
    };
  },

  async mounted() {
    // DOM güncellemesi tamamlandıktan sonra çalıştırılacak kod bloğu başlatılıyor
    this.$nextTick(async () => {
      // Kullanıcının program oranlarını getir
      await this.$store.dispatch("getMyProgramRates", {});
      // Belirtilen program ID'sine sahip programın oranlarını getir ve kullanıcıları da dahil et
      await this.$store.dispatch("getProgramRates", { programId: this.currentProgram.id, includeUsers: true });
    });
  },

  created() {},

  methods: {
    handleClick(tab, event) {},

    openImage(speaker) {
      $.fancybox.open({
        items: [speaker.image]
      });
    },

    getDay(dayID) {
      return this.currentProgramDays.find(k => k.id == dayID);
    },

    getSaloon(saloonID) {
      if (!this.currentProgramSaloons.some(k => k.id == saloonID)) {
        return false;
      } else {
        return this.currentProgramSaloons.find(k => k.id == saloonID);
      }
    },

    getDate(date) {
      return moment(date).format("Do MMMM");
    },

    getTime(time) {
      time = time.split(":");
      return moment()
        .set({ hours: time[0], minutes: time[1] })
        .format("HH:mm");
    },

    getSpeakerById(id) {
      var speaker = this.currentEventProgramSpeakers.find(x => x.speakerID == id);
      if (speaker == undefined) {
        speaker == null;
      }
      return speaker;
    },

    async register() {
      this.loading = "subevent";
      axios.defaults.headers["eventID"] = this.currentEvent.id;
      await axios
        .post("Participant/RegisterToSubEvent", {
          subEventID: this.currentProgram.subEventID,
          questions: []
        })
        .then(res => {
          this.snack = {
            show: true,
            message: res.data.message
          };
          this.$store.dispatch("getMySubEventRegistrations", {});
        });
      this.loading = null;
    },

    async sendRate() {
      axios.defaults.headers["eventID"] = this.currentEvent.id;
      this.rateForm.loading = true;
      await axios
        .post("Participant/RateProgram", {
          ...this.rateForm,
          programID: this.currentProgram.id
        })
        .then(res => {
          this.alert = {
            show: true,
            message: res.data.message
          };
          if (res.data.hasError == false) {
            this.showRateForm = false;
            this.rateForm.comment = null;
            this.rateForm.rate = 5;

            this.$store.dispatch("getProgramRates", { programId: this.currentProgram.id, includeUsers: true });
            this.$store.dispatch("getMyProgramRates", {});

            // axios.post("Participant/GetMyProgramRates").then(res => {
            //   this.$store.commit("setRates", res.data.data.items);
            // });
          }
        });
      this.rateForm.loading = false;
    },

    async deleteReview(review) {
      axios.defaults.headers["eventID"] = this.currentEvent.id;
      var res = await axios.post("Participant/DeleteRate", {
        programID: this.currentProgram.id
      });
      if (!res.data.hasError) {
        var index = this.currentProgramRates.findIndex(x => x.id == review);
        if (index != -1) {
          this.currentProgramRates.splice(index, 1);
        }
        await this.$store.dispatch("getMyProgramRates", {});
        this.showRateForm = true;
      } else {
        this.$message.error(res.data.message);
      }
    }
  },

  computed: {
    isAttending() {
      return this.$store.getters.getAttending;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentSubEventRegistration() {
      return this.$store.getters.getMySubEventRegistrations.find(x => x.subEventID == this.currentProgram.subEventID);
    },
    currentProgramRate() {
      return this.$store.getters.getMyProgramRates.some(x => x.programID == this.currentProgram.id);
    },
    currentProgramRates() {
      return this.$store.getters.getProgramRates;
    },
    currentProgram() {
      return this.$store.getters.getCurrentProgram;
    },
    currentEventPrograms() {
      return this.$store.getters.getPrograms;
    },
    currentEventProgramSpeakers() {
      return this.$store.getters.getProgramSpeakers;
    },
    currentProgramDays() {
      return this.$store.getters.getProgramDays;
    },
    currentProgramSaloons() {
      return this.$store.getters.getProgramSaloons;
    },
    currentProgramSpeakers() {
      //return this.$store.getters.getProgramSpeakers;
      return this.currentProgram.speakers;
    },
    currentSubEvent() {
      return this.$store.getters.getSubEvents.find(x => x.id == this.currentProgram.subEventID);
    },
    currentSubEventPrograms() {
      return this.currentEventPrograms.filter(x => x.subEventID == this.currentProgram.subEventID);
    }
  }
};
</script>

<style lang="less">
#programdetail-dialog {
  font-family: "Roboto", sans-serif;

  .programdetail-container {
    .container-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 10px;
      gap: 10px;
      .programdetail-section {
        margin-top: 1rem;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
        border-radius: 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 10px;
        & > .programdetail-section-header {
          width: 100%;
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          .programdetail-section-header-iconbox {
            width: 48px;
            height: 48px;
            background: #f1f3f6;
            border-radius: 48px;
            display: flex;
            flex-shrink: 0;
            align-items: center;
            justify-content: center;
            i {
              font-size: 24px;
            }
          }
          .programdetail-section-header-title {
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            word-break: break-word;
            color: #292f3b;
          }
        }
        .programdetail-section-body {
          .programdetail-section-speakers-container {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .programdetail-section-speaker-item {
              padding: 10px;
              background: #e8ebef;
              border-radius: 12px;
              display: flex;
              flex-direction: row;
              align-items: center;
              cursor: pointer;
              gap: 10px;

              .programdetail-section-speaker-item-text {
                display: flex;
                flex-direction: column;
                .programdetail-section-speaker-item-fullName {
                  font-weight: 600;
                  font-size: 16px;
                  text-align: start;
                  line-height: 24px;
                  color: #292f3b;
                }
                .programdetail-section-speaker-item-title {
                  font-weight: 400;
                  font-size: 12px;
                  text-align: start;
                  line-height: 18px;
                  color: #505763;
                }
              }
              img {
                width: 48px;
                height: 48px;
                object-fit: cover;
                border-radius: 50%;
                border: 1px solid #ffffff;
              }
            }
          }
          .programdetail-section-subevent-program-container {
            display: flex;
            flex-direction: column;
            gap: 10px;
            .subevent-program-item {
              border-radius: 8px;
              padding: 10px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              background: #e8ebef;
              border-radius: 12px;
              justify-content: center;

              .subevent-program-item-details {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                .date {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  gap: 10px;

                  span {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    color: #8c929c;
                    font-size: 13px;
                    font-weight: 400;

                    i {
                      margin-right: 6px;
                    }
                  }
                }

                span {
                  color: #8c929c;
                  font-size: 13px;
                  font-weight: 400;
                }
              }

              .subevent-program-title {
                p {
                  margin: 6px 0px;
                  font-size: 14px;
                  color: #292f3b;
                  font-weight: 500;
                  cursor: pointer;
                }
              }

              .subevent-program-speakers {
                display: flex;
                .subevent-program-speakers-item {
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                  border-radius: 50%;
                  border: 2px solid #ffffff;
                  width: 32px;
                  height: 32px;
                  display: inline-block;
                  margin-right: 6px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
      .programdetail-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
        border-radius: 16px;
        width: 100%;
        padding: 10px;

        .programdetail-program-title {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          margin: 0;
          word-break: break-word;
          color: #292f3b;
          text-align: center;
        }
        .programdetail-program-dates {
          display: flex;
          width: 100%;
          .programdetail-program-dates-item {
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: center;
            gap: 5px;
            .programdetail-program-dates-item-icon {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              background-color: #f1f3f6;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 24px;
              color: #268ea6;
            }
            .programdetail-program-dates-item-text {
              font-weight: 700;
              font-size: 14px;
              line-height: 20px;
              color: #505763;
            }
          }
        }
        .programdetail-program-saloon {
          width: max-content;
          padding: 8px 16px 8px 8px;
          background: #f1f3f6;
          border-radius: 32px;
          min-height: 40px;
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          display: flex;
          align-items: center;
          i {
            color: #268ea6 !important;
            margin-left: 6px;
          }
          color: #292f3b;
        }
        .programdetail-program-details {
          p,
          br,
          hr,
          span {
            margin: 0px;
          }

          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            margin: 2px 0px;
          }
        }
        p {
          margin: 6px 0;
          color: #8c929c;
          font-size: 14px;
          font-weight: 400;

          i {
            margin-right: 6px;

            &:nth-child(2) {
              margin-left: 10px;
            }
          }
        }
      }

      .programdetail-reviewcard {
        background-color: #f6f6f6;
        padding: 12px;
        border-radius: 8px;
        width: 100%;
        margin: 12px 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .programdetail-review {
          span {
            font-weight: 500;
            color: #292f3b;
          }
          button {
            span {
              color: white;
            }
          }
        }
      }

      .programdetail-subevent-header {
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
        border-radius: 16px;
        padding: 10px;
        width: 100%;
        margin: 12px 0;
        margin-top: 0;

        .programdetail-subevent-top {
          display: flex;
          flex-direction: column;
          gap: 10px;
          justify-content: center;
          align-items: center;

          .programdetail-subevent-icon-box {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            border: 3px solid #f69656;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            i {
              color: #f69656;
            }
          }
          .subevent-title {
            margin: 6px 0px;
            font-size: 16px;
            color: #292f3b;
            font-weight: 500;
          }
          .subevent-line {
            height: 0.5px;
            width: 100%;
            background-color: #c8cdd3;
          }
          .subevent-limit {
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            color: #8c929c;
          }
        }

        p {
          margin: 6px 0;
          color: #8c929c;
          font-size: 14px;
          font-weight: 400;
        }

        button {
          span {
            color: white;
          }
        }
      }

      .reviews-review-item {
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        text-align: left;
        background-color: white;
        padding: 10px;
        border-radius: 12px;

        &:last-child {
          border-bottom: unset;
        }

        .review-item-header {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          .review-item-photo {
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 50%;
            border: 3px solid #f1f1f1;
            width: 42px;
            height: 42px;
            display: inline-block;
            position: absolute;
          }

          .review-item-header-text {
            display: flex;
            flex-direction: row;
            align-items: center;

            .review-item-text {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              margin-left: 50px;

              h5 {
                margin: 0px;
                font-size: 14px;
                color: #292f3b;
                font-weight: 500;

                span {
                  margin: 0px;
                  font-size: 13px;
                  color: #8c929c;
                  font-weight: 400;
                  margin-left: 6px;
                }
              }
            }
          }
        }

        .review-item-body {
          margin-top: 6px;
          font-size: 13px;
          color: #505763;
        }

        .review-item-actions {
          padding: 6px;
          cursor: pointer;
        }
      }

      .send-review-bar {
        width: 100%;
        height: 120px;
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        position: relative;
        font-family: "Roboto", sans-serif;

        .review-select-stars {
          font-size: 20px;
          margin-bottom: 8px;
        }

        textarea {
          width: 100%;
          border: 0;
          height: 100px !important;
          border-radius: 8px;
          outline: none;
          padding: 8px 12px;
          box-sizing: border-box;
          border: 0.5px solid #d6d9d9;
          background: #fbfbfb;
          font-family: "Roboto", sans-serif;
          font-size: 13px;
        }

        button {
          color: #292f3b;
          font-size: 16px;
          font-weight: 600;
          font-family: "Roboto", sans-serif;
          background: transparent;
          border: unset;
          box-shadow: unset;
          position: absolute;
          cursor: pointer;
          right: 5px;
          top: 0px;
        }
      }
    }
  }

  .modal-footer {
    gap: 1rem;
    .left-buttons {
      width: 100%;
    }
  }

  .review-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    position: relative;
    .el-input {
      width: 100%;
      input {
        padding-right: 100px;
      }
    }
    .review-stars {
      position: absolute;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgramDetailDialog.vue